import {ErrorMessage, Field} from 'formik';
import {useTranslation} from 'react-i18next';

import {Box, Grid, Typography} from '@mui/material';

import money_bill_icon from '../../../../../../../../../assets/job_postings/icons/money-bill-icon.png';
import {EmpionTextField} from '../../../../../../../../../components/EmpionTextField/EmpionTextField';

export const HardFactsFieldsSalary = () => {
  const {t} = useTranslation();

  return (
    <Grid container display={'flex'} flexDirection={'row'}>
      <Grid item xs={12} display={'flex'} gap={2}>
        <Grid container item xs={12} spacing={1} justifyContent={'space-between'}>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '5px',
              '& .MuiGrid-item': {
                padding: '0px',
              },
            }}
          >
            <Box component='img' src={money_bill_icon} alt='money_bill_icon' />
            <Field
              type='number'
              name='salary.min'
              label={`${t('companyJobPostings.newJobDialog.formLabels.salaryMin')}`}
              component={EmpionTextField}
              size={'small'}
              fullWidth
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '5px',
              '& .MuiGrid-item': {
                padding: '0px',
              },
            }}
          >
            <Box component='img' src={money_bill_icon} alt='money_bill_icon' />
            <Field
              type='number'
              name='salary.max'
              label={`${t('companyJobPostings.newJobDialog.formLabels.salaryMax')}`}
              component={EmpionTextField}
              size={'small'}
              fullWidth
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Box ml={3}>
          <Typography variant='body2' color='error'>
            <ErrorMessage name='salary' component='span' />
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};
